

// upload Cart
export const uploadCartSuccess = (envois)=>({
    type: 'UPLOAD_CART_SUCCESS',
    payload: envois
})

export const removeFromCart = (id)=>({
    type: 'REMOVE_FROM_CART',
    payload: id,
})

// clear Cart
export const clearCart = ()=>({
    type: 'CLEAR_CART',
})

// remove cart and message
export const restartCart = ()=>({
    type: 'RESTART_CART'
})

// Add Action
export const addActionStart = ()=>({
    type: 'ADD_ACTION_START',
});
export const addActionSuccess = (mess)=>({
    type: 'ADD_ACTION_SUCCESS',
    payload: mess,
});
export const addActionFailure = (error)=>({
    type: 'ADD_ACTION_FAILURE',
    payload: error,
});

// Add Action Etat
export const addActionEtatStart = ()=>({
    type: 'ADD_ACTION_ETAT_START',
});
export const addActionEtatSuccess = (mess)=>({
    type: 'ADD_ACTION_ETAT_SUCCESS',
    payload: mess,
});
export const addActionEtatFailure = (error)=>({
    type: 'ADD_ACTION_ETAT_FAILURE',
    payload: error,
});


// Get One Envoie
export const getCartEnvoieStart = ()=>({
    type: 'GET_CART_ENVOIE_START',
})
export const getCartEnvoieSuccess = (envoie)=>({
    type: 'GET_CART_ENVOIE_SUCCESS',
    payload: envoie
})
export const getCartEnvoieFailure = (error)=>({
    type: 'GET_CART_ENVOIE_FAILURE',
    payload: error
})